'use client';

import { Search } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SearchIconButtonProps {
  /**
   * Size of the icon in pixels (default: 16)
   */
  size?: number;
  /**
   * Size of the icon in pixels (default: 16)
   */
  iconSize?: number;
  /**
   * Additional class names to apply to the button
   */
  className?: string;
  /**
   * Callback when button is clicked
   */
  onClick?: () => void;
}

export function SearchIconButton({
  size = 24,
  iconSize,
  onClick,
  className,
}: SearchIconButtonProps) {
  // Default iconSize to 75% of button size if not provided
  const resolvedIconSize = iconSize ?? size * 0.75;
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        'group relative size-8 p-0 hover:cursor-pointer',
        'hover:bg-accent hover:scale-105 active:scale-100',
        'transition-transform duration-200',
        'focus-visible:ring-ring focus-visible:ring-1 focus-visible:ring-offset-1',
        className
      )}
      onClick={onClick}
      aria-label="Open search"
      style={{ width: size, height: size }}
    >
      <Search
        style={{ width: resolvedIconSize, height: resolvedIconSize }}
        className="text-muted-foreground group-hover:text-white"
      />
    </Button>
  );
}
